require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./people-archive-people-rich-haddlesey.json") })
        }
      }, "path---people-archive-people-rich-haddlesey");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---people-archive-people-rich-haddlesey!./.cache/json/people-archive-people-rich-haddlesey.json
// module id = 1448
// module chunks = 231608221292675